import React, { Component } from 'react';
import { AlertTriangle } from 'lucide-react';
interface Props {
  children?: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };
  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex items-center justify-center bg-background p-4" data-id="element-3220" data-mp="1w2euzlq7gp7z">
          <div className="bg-card border border-border rounded-2xl p-6 max-w-md w-full text-center space-y-4 shadow-xl" data-id="element-3221" data-mp="1s0jw0nvqynxd">
            <div className="w-12 h-12 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3222" data-mp="3qe3fe3f7hjzr">
              <AlertTriangle className="w-6 h-6 text-red-500" data-id="element-3223" data-mp="3meksx37ql0ut" />
            </div>
            <h2 className="text-xl font-bold text-foreground" data-id="element-3224" data-mp="1v8xdx4hlocn5">
              Er is iets misgegaan
            </h2>
            <p className="text-muted-foreground text-sm" data-id="element-3225" data-mp="20acvunohe31b">
              Er is een onverwachte fout opgetreden. Probeer de pagina te
              vernieuwen.
            </p>
            {this.state.error && <div className="mt-4 p-3 bg-muted rounded-lg text-left overflow-auto" data-id="element-3226" data-mp="1qcoqz4x5vf5f">
                <p className="text-xs text-muted-foreground font-mono break-all" data-id="element-3227" data-mp="2e0q64wouhttt">
                  {this.state.error.toString()}
                </p>
              </div>}
            <button onClick={() => window.location.reload()} className="w-full mt-6 px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-background" data-id="element-3228" data-mp="2573dvgjuj8pd">
              Pagina vernieuwen
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}